import { useEffect, useState } from 'react';

// Utils
import SCREEN_DIMENSIONS from 'constants/screenDimensions';

export const DIMENSION_GROUPS = {
  mobile: 'mobile',
  tablet: 'tablet',
  desktop: 'desktop',
};

/**
 *@author Andrey Sukhov
 *@description хук для определения типа лейаута;
 *@returns { object }
 */
const useGetDimensionGroup = () => {
  const [group, setGroup] = useState(null);

  const handleResize = () => {
    if (!window) {
      setGroup(null);
    }
    if (window.innerWidth <= SCREEN_DIMENSIONS.mobile) {
      setGroup(DIMENSION_GROUPS.mobile);
    } else if (
      window.innerWidth > SCREEN_DIMENSIONS.mobile
      && window.innerWidth <= SCREEN_DIMENSIONS.tablet) {
      setGroup(DIMENSION_GROUPS.tablet);
    } else {
      setGroup(DIMENSION_GROUPS.desktop);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return group;
};

const useIsMobileDimension = () => {
  const dimension = useGetDimensionGroup();
  return dimension === DIMENSION_GROUPS.mobile;
};

export { useGetDimensionGroup, useIsMobileDimension };
